import { useRef, useEffect } from "react";

// Custom hook to get the previous value of a variable
export default function usePrevious(value) {
  // Create a ref to store the previous value
  const ref = useRef();

  // useEffect to update the ref with the current value whenever it changes
  useEffect(() => {
    ref.current = value;
  }, [value]);

  // Return the previous value
  return ref.current;
}
